module.exports = __webpack_public_path__ + "img/87.b2bc413d.png";